import React, { Fragment, StrictMode } from "react";
import { hot } from "react-hot-loader/root";

import { Routes } from "#/routes/routes";
import { Meta } from "@sicredi/react";
import { GlobalContextProvider } from "#/context/Global";
import AuthProvider from "#/providers/AuthProvider";

export const App: React.FC = () => {
  return (
    <Fragment>
      <Meta titleTemplate="%s - Sicredi" defaultTitle="Sicredi" />

      <main>
        <StrictMode>
          <AuthProvider>
            <GlobalContextProvider>
              <Routes />
            </GlobalContextProvider>
          </AuthProvider>
        </StrictMode>
      </main>
    </Fragment>
  );
};

export default hot(App);
